<template>

    <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">

            <ButtonsIcon 
                :icon="icon"
                :color="color"
                small
                @clicked="emit('clicked', $event)"
                v-bind="attrs"
                v-on="on"
            />

        </template>

        <span>{{ tooltip }}</span>

    </v-tooltip>
</template>

<script setup>

import { defineEmits, defineProps } from 'vue';

const emit = defineEmits(['clicked'])

const props = defineProps({
    icon: { type: String, default: 'mdi-thumb-up' },
    color: { type: String, default: 'grey' },
    tooltip: { type: String, default: 'Resposta satisfatória' }
})

</script>